<template>
    <div class="top">

        <section>
            <div class="container">
                <h2>
                    Profile
                </h2>
                <p>
                    ここには概要説明のテキストを入力します。
                </p>
                <p>
                    ここには概要説明のテキストを入力します。
                    ここには概要説明のテキストを入力します。
                    ここには概要説明のテキストを入力します。
                    ここには概要説明のテキストを入力します。
                </p>
                <p>
                    <a href="" class="btn">More...</a>
                </p>
            </div>
        </section>

        <section>
            <div class="container">
                <h2>
                    Webpages
                </h2>
                <p>
                    ここには概要説明のテキストを入力します。
                </p>
                <p>
                    <a href="" class="btn">More...</a>
                </p>
            </div>
        </section>
    </div>
</template>

<script>
    export default {
        name: 'top',
        title: 'Top', // title 追加
        description: ' ポートフォリオサイト ', // description 追加
        props: ['data']
    }
</script>

<!-- Add "scoped" attribute to limit CSS to this component only -->
<style scoped>
    h1, h2 {
        font-weight: normal;
    }

    ul {
        list-style-type: none;
        padding: 0;
    }

    li {
        display: inline-block;
        margin: 0 10px;
    }

    a {
        color: #42b983;
    }
</style>



// WEBPACK FOOTER //
// src/components/Top.vue